/** English copy for the invited-partner journey. Merge into the app locale catalog. */
export const partnerOnboardingMessages = {
  "partnerLifecycle.production.active": "API approval does not launch customer checkout. Confirm the customer payment and delivery flow with Tinkr before going live.",
  "partnerOnboarding.eyebrow": "Your API journey",
  "partnerOnboarding.title": "Build with Tinkr",
  "partnerOnboarding.intro": "Your sandbox is ready. Follow these steps to test your integration and request live access.",
  "partnerOnboarding.checkoutAvailability": "API approval does not launch customer checkout. Confirm the customer payment and delivery flow with Tinkr before going live.",
  "partnerOnboarding.access": "Partner access approved",
  "partnerOnboarding.accessDetail": "Your account is ready for sandbox development.",
  "partnerOnboarding.sandboxKey": "Create a sandbox key",
  "partnerOnboarding.sandboxKeyDetail": "Create a key in API keys to make your first test call.",
  "partnerOnboarding.test": "Test your integration",
  "partnerOnboarding.testDetail": "Use the sandbox and API reference to try the flow. Testing is your own checkpoint.",
  "partnerOnboarding.identity": "Verify your identity",
  "partnerOnboarding.identityDetail": "Complete a secure Stripe Identity check before production approval. Your sandbox access stays available.",
  "partnerOnboarding.business": "Business review",
  "partnerOnboarding.businessDetail": "Submit your existing business information for Tinkr review before production approval.",
  "partnerOnboarding.governanceEyebrow": "Production readiness",
  "partnerOnboarding.governanceTitle": "Verify before launch",
  "partnerOnboarding.governanceIntro": "Identity verification and Tinkr's business review are separate checks for new production approvals. You can keep building in the sandbox while they are in progress.",
  "partnerOnboarding.governanceLoading": "Checking verification status…",
  "partnerOnboarding.governanceError": "We couldn't load your verification status. Please try again.",
  "partnerOnboarding.governanceRefresh": "Check status",
  "partnerOnboarding.identityStart": "Start identity verification",
  "partnerOnboarding.identityPreparing": "Preparing your secure verification link. This may take a moment; you can check the status here.",
  "partnerOnboarding.identityNewLink": "Get a new verification link",
  "partnerOnboarding.identityContinue": "Continue secure verification",
  "partnerOnboarding.businessSubmit": "Submit for business review",
  "partnerOnboarding.businessEvidenceHelp": "Enter the registration details for the business named in your partner application. Tinkr reviews this declaration; it is not automatic verification.",
  "partnerOnboarding.registrationCountry": "Registration country",
  "partnerOnboarding.chooseCountry": "Select a country",
  "partnerOnboarding.registrationNumber": "Business registration number",
  "partnerOnboarding.businessPending": "Tinkr is reviewing your business information.",
  "partnerOnboarding.businessFeedback": "Feedback from Tinkr:",
  "partnerOnboarding.payoutSeparate": "Payout currency registration is separate from API access and launch review.",
  "partnerOnboarding.openPayouts": "Open Payouts",
  "partnerOnboarding.identityStatus.not_started": "Not started",
  "partnerOnboarding.identityStatus.requires_input": "Action needed",
  "partnerOnboarding.identityStatus.processing": "Processing",
  "partnerOnboarding.identityStatus.verified": "Verified",
  "partnerOnboarding.identityStatus.failed": "Failed — try again",
  "partnerOnboarding.identityStatus.cancelled": "Cancelled — try again",
  "partnerOnboarding.identityStatus.expired": "Expired — try again",
  "partnerOnboarding.businessStatus.not_submitted": "Not submitted",
  "partnerOnboarding.businessStatus.pending": "Under review",
  "partnerOnboarding.businessStatus.approved": "Approved",
  "partnerOnboarding.businessStatus.rejected": "More information needed",
  "partnerOnboarding.businessStatus.more_information_required": "More information needed",
  "partnerOnboarding.launch": "Request app launch review",
  "partnerOnboarding.launchDetail": "Tell us about your app, customer handling, and payment flow.",
  "partnerOnboarding.productionKey": "Create a production key",
  "partnerOnboarding.productionKeyDetail": "Live keys become available after production approval.",
  "partnerOnboarding.createSandboxKey": "Create sandbox key",
  "partnerOnboarding.createLiveKey": "Create production key",
  "partnerOnboarding.openDocs": "Open API reference",
  "partnerOnboarding.openSandbox": "Open sandbox",
  "partnerOnboarding.awaitingReview": "Your launch request is being reviewed. Sandbox access remains available.",
  "partnerOnboarding.ready": "Your production access is ready.",
  "partnerOnboarding.complete": "Your integration has live access and a production key.",
  "partnerOnboarding.paused": "Your partner access is paused. Contact Tinkr support for help.",
  "partnerOnboarding.closed": "Your partner access has been closed.",
  "partnerOnboarding.next": "Next step",
  "partnerOnboarding.done": "Done",
  "partnerOnboarding.available": "Available",
  "partnerOnboarding.waiting": "Waiting",
  "partnerOnboarding.guidance": "Guide",
  "partnerOnboarding.countries": "Target countries (optional)",
  "partnerOnboarding.addCountry": "Add a country",
  "partnerOnboarding.removeCountry": "Remove country",
  "partnerOnboarding.notes": "Additional notes (optional)",
  "partnerOnboarding.yes": "Yes",
  "partnerOnboarding.no": "No",
  "partnerOnboarding.changesRequested": "Changes requested before launch",
  "partnerOnboarding.notApproved": "Launch request was not approved",
  "partnerOnboarding.reviseApplication": "Revise launch request",
  "partnerOnboarding.launchSteps": "Launch request steps",
  "partnerOnboarding.stepBasics": "App basics",
  "partnerOnboarding.stepHandling": "Customer handling",
  "partnerOnboarding.stepReview": "Review",
  "partnerOnboarding.validUrl": "Enter an http or https URL.",
  "partnerOnboarding.validEmail": "Enter a valid support email.",
  "partnerOnboarding.reviewHint": "Check these details before sending your launch request.",
  "partnerOnboarding.back": "Back",
  "partnerOnboarding.continue": "Continue"
} as const;
